import { request } from './request'

export interface GetTemplateDetail {
  template_id: string
  template_type: number //模板类型 1 附件  2 链接 3 畸形邮件
}
export const getTemplateDetail = (data: GetTemplateDetail) =>
  request('/portal/verify/emailGateway/templateDetail', {
    params: {
      ...data,
    },
  })

//获取安全域目标邮箱
export const getTargets = () => request('/portal/verify/emailGateway/targetList')
// 获取发件地址
export const getEmailList = () => request('/portal/verify/emailGateway/emailList')

export interface CreateTaskData {
  name: string
  hostname: string
  email: string
  biz_area_name: string
  scheduler_type: number
  task_time?: string
  day?: string
  day_of_week?: string
  agent_id: string
  email_id: string
  biz_area_id: string
  template_list: number[]
  is_email: number
  email_list: string[]
  delay: number
}

export const createTask = (data: CreateTaskData) =>
  request('/portal/verify/emailGateway/createTask', {
    method: 'post',
    data,
    timeout: 60 * 1000,
  })

//获取ATT&CK列表
export const getAttCkList = () => request('/portal/verify/emailGateway/attCkList')

// 关联安全设备
export interface GetSecurityDevice {
  emailId: string
}
export const getSecurityDevice = data =>
  request('/portal/verify/email_gateway/task_create/devices', {
    method: 'get',
    params: data,
  })

// 获取模板列表
export interface GetTemplateList {
  /**
   * 模板名字
   */
  'filterParams.name'?: string
  /**
   * 来源类型
   *
   * - OriginTypeSystem: 系统内置
   * - OriginTypeCustom: 手动添加
   */
  'filterParams.originType'?: FilterParamsOriginType
  /**
   * 关联场景ids
   */
  'filterParams.sceneIds'?: number[]
  /**
   * 排序字段
   *
   * - TemplateSortFieldUpdateTime: 更新时间
   * - TemplateSortFieldResourceAmount: 用例数量
   */
  'filterParams.sortField'?: FilterParamsSortField
  /**
   * 排序方式
   *
   * - SortOrderUnspecified: 默认值，未指定排序方式
   * - SortOrderAscending: 正序
   * - SortOrderDescending: 倒序
   */
  'filterParams.sortOrder'?: FilterParamsSortOrder
  /**
   * 验证模式ids
   */
  'filterParams.verificationModeIds'?: number[]
  /**
   * 页码
   */
  page?: number
  /**
   * 页大小
   */
  pageSize?: number
  [property: string]: any
}

/**
 * 来源类型
 *
 * - OriginTypeSystem: 系统内置
 * - OriginTypeCustom: 手动添加
 */
export enum FilterParamsOriginType {
  OriginTypeCustom = 'OriginTypeCustom',
  OriginTypeSystem = 'OriginTypeSystem',
  OriginTypeUnknown = 'OriginTypeUnknown',
}

/**
 * 排序字段
 *
 * - TemplateSortFieldUpdateTime: 更新时间
 * - TemplateSortFieldResourceAmount: 用例数量
 */
export enum FilterParamsSortField {
  TemplateSortFieldResourceAmount = 'TemplateSortFieldResourceAmount',
  TemplateSortFieldUnknown = 'TemplateSortFieldUnknown',
  TemplateSortFieldUpdateTime = 'TemplateSortFieldUpdateTime',
}

/**
 * 排序方式
 *
 * - SortOrderUnspecified: 默认值，未指定排序方式
 * - SortOrderAscending: 正序
 * - SortOrderDescending: 倒序
 */
export enum FilterParamsSortOrder {
  SortOrderAscending = 'SortOrderAscending',
  SortOrderDescending = 'SortOrderDescending',
  SortOrderUnspecified = 'SortOrderUnspecified',
}

export const getTemplateList = (data: GetTemplateList) =>
  request('/portal/common/resourceTemplates', {
    method: 'post',
    data,
  })

export interface GetCaseList {
  /**
   * 攻击类型id
   */
  'filterParams.attackTypeId'?: string
  /**
   * 用例名称
   */
  'filterParams.name'?: string
  /**
   * 来源类型
   *
   * - OriginTypeSystem: 系统内置
   * - OriginTypeCustom: 手动添加
   */
  'filterParams.originType'?: FilterParamsOriginType
  /**
   * 用例分级
   *
   * - ResourceLevelJunior: 初级
   * - ResourceLevelMiddle: 中级
   * - ResourceLevelSenior: 高级
   */
  'filterParams.resourceLevel'?: FilterParamsResourceLevel
  /**
   * 危险等级
   *
   * - RiskLevelLow: 低危
   * - RiskLevelMiddle: 中危
   * - RiskLevelHigh: 高危
   * - RiskLevelGross: 严重
   */
  'filterParams.riskLevel'?: FilterParamsRiskLevel
  /**
   * 排序字段
   */
  'filterParams.sortField'?: FilterParamsSortField
  /**
   * 排序方式
   *
   * - SortOrderUnspecified: 默认值，未指定排序方式
   * - SortOrderAscending: 正序
   * - SortOrderDescending: 倒序
   */
  'filterParams.sortOrder'?: FilterParamsSortOrder
  /**
   * 标签ids
   */
  'filterParams.tagId'?: string[]
  'filterParams.templateId'?: string[]
  /**
   * 验证模式id
   */
  'filterParams.verificationModeId'?: number
  /**
   * 页码
   */
  page?: number
  /**
   * 页大小
   */
  pageSize?: number
  templateId?: string[]
  [property: string]: any
}

/**
 * 来源类型
 *
 * - OriginTypeSystem: 系统内置
 * - OriginTypeCustom: 手动添加
 */

/**
 * 用例分级
 *
 * - ResourceLevelJunior: 初级
 * - ResourceLevelMiddle: 中级
 * - ResourceLevelSenior: 高级
 */
export enum FilterParamsResourceLevel {
  ResourceLevelJunior = 'ResourceLevelJunior',
  ResourceLevelMiddle = 'ResourceLevelMiddle',
  ResourceLevelSenior = 'ResourceLevelSenior',
  ResourceLevelUnknown = 'ResourceLevelUnknown',
}

/**
 * 危险等级
 *
 * - RiskLevelLow: 低危
 * - RiskLevelMiddle: 中危
 * - RiskLevelHigh: 高危
 * - RiskLevelGross: 严重
 */
export enum FilterParamsRiskLevel {
  RiskLevelGross = 'RiskLevelGross',
  RiskLevelHigh = 'RiskLevelHigh',
  RiskLevelLow = 'RiskLevelLow',
  RiskLevelMiddle = 'RiskLevelMiddle',
  RiskLevelUnknown = 'RiskLevelUnknown',
}

// 获取关联用例列表
export const getCaseList = (data: GetCaseList) =>
  request(`/portal/common/resourceTemplate/resources`, {
    method: 'post',
    data,
  })

export interface SaveCaseToTemplate {
  /**
   * 描述
   */
  description?: string
  /**
   * 模板名字
   */
  name?: string
  /**
   * 关联用例ids
   */
  resourceIds?: string[]
  /**
   * 关联场景ids
   */
  sceneIds?: string[]
  /**
   * 验证模式ids
   */
  verificationModeIds?: string[]
  [property: string]: any
}

// 保存已选择用例为模板
export const saveCaseToTemplate = (data: SaveCaseToTemplate) =>
  request(`/portal/common/resourceTemplate`, {
    method: 'post',
    data,
  })

// 定义接口类型
export enum V1ResourceCenterOriginType {
  OriginTypeCustom = 'OriginTypeCustom',
  OriginTypeSystem = 'OriginTypeSystem',
  OriginTypeUnknown = 'OriginTypeUnknown',
}

export interface V1GetResourceTemplateListReplyTemplateItem {
  description?: string
  name?: string
  originType?: V1ResourceCenterOriginType
  resourceAmount?: number
  resourceIds?: string[]
  sceneIds?: number[]
  updateTime?: Date
  verificationModeIds?: number[]
  [property: string]: any
}

export interface TemplateResponse {
  list?: V1GetResourceTemplateListReplyTemplateItem[]
  total?: number
  [property: string]: any
}

// 用例详情
export interface GetCaseDetail {
  resourceId: string
  type: 'url' | 'attachment'
}

export const getCaseDetail = (data: GetCaseDetail) =>
  request(`/portal/common/resource/email/${data.type}/${data.resourceId}`, {
    method: 'get',
  })

// 获取所有模板id
export const getAllTemplateId = (data: GetTemplateList) =>
  request('/portal/common/resourceTemplates/ids', {
    method: 'post',
    data,
  })

// 获取所有用例id
export const getAllCaseId = (data: GetCaseList) =>
  request('/portal/common/resourceTemplate/filterResourceIds', {
    method: 'post',
    data,
    timeout: 8 * 1000,
  })

// 攻击类型
export interface GetAttackTypeList {
  taskId: string
  templateId: string
}
export const getAttackTypeList = data =>
  request(`/portal/common/attack/attack_type_filter_list`, {
    method: 'get',
    params: data,
    data,
  })

// 获取用例标签
export const getResourceTagList = data =>
  request('/portal/common/resources/tag/list', {
    method: 'post',
    data,
  })

// 根据templateIds获取resourceIds
export const getResourceIdsByTemplateIds = data =>
  request('/portal/common/resourceTemplate/filter/ResourceIds', {
    method: 'post',
    data,
  })

// 获取安全域列表
export const getTargetList = data =>
  request('/portal/verify/emailGateway/targetList', {
    method: 'get',
    params: data,
  })

// 获取Agent列表
export const getAgentList = data =>
  request('/portal/verify/email_gateway/task_create/agent', {
    method: 'get',
    params: data,
  })

// 获取邮箱发送列表
export const getEmailSendList = () => request('/portal/common/email_users')
